export const notificationsActionTypes = {
    NOTIFICATIONS_SYNC_REQUESTED: 'NF1',
    NOTIFICATIONS_SYNCED:         'NF2',
    NOTIFICATION_RECEIVED:        'NF3',
    NOTIFICATION_MARK_READ:       'NF4',
    NOTIFICATIONS_RESET:          'NF5',
};
